import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import UserAvatar from 'modules/core/components/UserAvatar'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import locations from 'modules/locations/store/collections/locations'
import type Location from 'modules/locations/store/models/Location'

import styles from './index.module.scss'

interface Props {
  employee: Employee
  location: Location
}

const Item = ({ employee, location }: Props) => {
  const { navigation } = useNavigation()
  const [open, toggle] = useToggle()

  const getOptions = () => {
    const options = []

    if (locations.models.length > 1) {
      const id = location.attributes.id
      const employeeId = employee.attributes.id
      options.push({
        to: navigation.settings.locations.locationsId.employees.moveEmployeeId.fullPath({
          id,
          employeeId,
        }),
        title: i18n.t('settings.locations.location.employees.actions.assign'),
      })
    }

    return options
  }

  const renderDropdown = () => {
    const options = getOptions()

    if (!options.length) return null

    return (
      <Popover attachment="top center" targetAttachment="bottom center" toggle={toggle} open={open}>
        <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
        <PopoverContent onClose={toggle(false)} options={options} />
      </Popover>
    )
  }

  const renderOptions = () => {
    return (
      <div className={styles.actions}>
        <div className={styles.marginRight}>{renderDropdown()}</div>
        <div>
          <Button.Router
            to={navigation.employees.id.fullPath({ id: employee.id })}
            type="secondary"
            iconName="arrow-right"
          />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <div className={styles.details}>
          <div className={styles.avatar}>
            <UserAvatar user={employeeUser(employee)} />
          </div>
          <div className={styles.name}>{employeeUser(employee).fullName()}</div>
        </div>
        {renderOptions()}
      </div>
    </div>
  )
}

export default observer(Item)
